import { authHeader, BASE_URL, handleResponse } from '@helpers/api';

export const facebookIntegrationService = {
    disconnectIntegration,
    authenticateFacebookIntegration,
    getPages,
    editProfile,
    getLocationListing,
    updateLocationListing,
    authenticateMetaBusinessIntegration,
};

function getPages() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/facebook/pages`, requestOptions).then(handleResponse);
}

function disconnectIntegration() {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/facebook/disconnect-integration`, requestOptions).then(handleResponse);
}

function authenticateFacebookIntegration(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/facebook/connect-integration`, requestOptions).then(handleResponse);
}

function authenticateMetaBusinessIntegration(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/facebook/authenticate-system-user`, requestOptions).then(handleResponse);
}

function editProfile(locationId, data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/locations/${locationId}/integrations/facebook:connect`, requestOptions).then(
        handleResponse,
    );
}

function getLocationListing(locationId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/locations/${locationId}/integrations/facebook/listing`, requestOptions).then(
        handleResponse,
    );
}

function updateLocationListing(locationId, data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/locations/${locationId}/integrations/facebook/listing`, requestOptions).then(
        handleResponse,
    );
}
